<template>
  <div>
    <div style="padding: 0 20px; overflow-y: auto; height: calc(100vh - 120px)">
      <el-form
        ref="sysInfoRuleForm"
        :model="sysInfoObj"
        :rules="sysInfoObjRules"
        label-position="top"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="10">
            <!--  消息类型   -->
            <el-form-item :label="$t('customerManagements.messageType')" prop="msgTypeInfo">
              <el-radio-group v-model="sysInfoObj.msgTypeInfo" @change="changeMsgTypeInfo">
                <el-radio :label="1">{{ $t('GlobalSetObj.sysMessage') }}</el-radio>
                <el-radio :label="2">{{ $t('GlobalSetObj.announcement') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <!--  系统   -->
            <el-form-item :label="$t('GlobalSetObj.system')" prop="systemType">
              <el-radio-group v-model="sysInfoObj.systemType" @change="handleSystemType">
                <el-radio :label="0">{{ $t('GlobalSetObj.all') }}</el-radio>
                <el-radio :label="1">{{ $t('customerManagements.expressSystem') }}</el-radio>
                <el-radio :label="2">{{ $t('customerManagements.providerSystem') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <div v-if="sysInfoObj.msgTypeInfo === 1">
            <el-col :span="10">
              <!--  用户端   -->
              <el-form-item :label="$t('customerManagements.userSide')" prop="clientType">
                <el-radio-group v-model="sysInfoObj.clientType" @change="handleClientType">
                  <el-radio :label="0">{{ $t('GlobalSetObj.all') }}</el-radio>
                  <el-radio :label="1">{{ 'PC' }}</el-radio>
                  <el-radio :label="2">{{ 'APP' }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--提示类型-->
              <el-form-item :label="$t('customerManagements.notificationType')" prop="reminder">
                <el-radio-group v-model="sysInfoObj.reminder" @change="handleClientType">
                  <el-radio :label="0">{{ $t('customerManagements.weakReminder') }}</el-radio>
                  <el-radio :label="1">{{ $t('customerManagements.strongReminder') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col v-if="sysInfoObj.systemType !== 0" :span="24">
              <!-- 接收用户 -->
              <el-form-item :label="$t('spareNumberPoo.receivingUser')" prop="receiveUser">
                <el-radio-group v-model="sysInfoObj.receiveUser" @change="changeReceiveUser">
                  <el-radio :label="1">{{ $t('spareNumberPoo.allUsers') }}</el-radio>
                  <el-radio :label="0">{{ $t('spareNumberPoo.specifiedUser') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col v-if="sysInfoObj.receiveUser !== 1" :span="12">
              <!--  网点所属州  -->
              <el-form-item :label="$t('basicData.StateOfOutlet')">
                <el-select
                  v-model="sysInfoObj.state"
                  :disabled="isState"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable
                  filterable
                  multiple
                  style="width: 100%"
                  @change="changeState"
                >
                  <el-option
                    v-for="item in StateList"
                    :key="item.id"
                    :label="item.label"
                    :value="item.label"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="sysInfoObj.systemType !== 1 && sysInfoObj.receiveUser !== 1" :span="12">
              <!--服务商 / 网点-->
              <el-form-item :label="$t('customerManagements.providerSite')" prop="providerId">
                <el-cascader
                  v-if="sysInfoObj.systemType === 2"
                  v-model="sysInfoObj.providerId"
                  :disabled="isProviderIdDisable"
                  :options="siteData"
                  :props="{ multiple: true, checkStrictly: true }"
                  clearable
                  filterable
                  size="small"
                  style="width: 100%"
                  @change="handleObj"
                />
                <el-select
                  v-else
                  v-model="sysInfoObj.providerId"
                  :disabled="isProviderIdDisable"
                  clearable
                  filterable
                  multiple
                  size="small"
                  style="width: 100%"
                  @change="handleObj"
                >
                  <el-option
                    v-for="item in siteListData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="sysInfoObj.receiveUser !== 1" :span="12">
              <!-- 账号 -->
              <el-form-item :label="$t('customerManagements.account')" prop="userList">
                <el-select
                  v-model.trim="sysInfoObj.userList"
                  :disabled="isProviderIdDisable"
                  :placeholder="$t('GlobalSetObj.Only10AreDisplayed')"
                  :remote-method="getAllUserList"
                  clearable
                  filterable
                  multiple
                  remote
                  reserve-keyword
                  style="width: 100%"
                  @change="changeUserList"
                  @visible-change="handleAllUserList"
                >
                  <el-option
                    v-for="item in accountList"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="sysInfoObj.userList.length > 0 && sysInfoObj.systemType === 2" :span="12">
              <!--  是否是虚假签收警告? -->
              <el-form-item :label="$t('spareNumberPoo.isFalseDeliveryWarning')" prop="isWarning">
                <el-select
                  v-model="sysInfoObj.isWarning"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable
                  style="width: 100%"
                >
                  <el-option key="0" :label="$t('GlobalSetObj.No')" :value="false" />
                  <el-option key="1" :label="$t('GlobalSetObj.yes')" :value="true" />
                </el-select>
              </el-form-item>
            </el-col>
          </div>
          <el-col :span="24">
            <!-- 标题 -->
            <el-form-item :label="$t('customerManagements.headline')" prop="title">
              <el-input
                v-model="sysInfoObj.title"
                :placeholder="$t('orderDetails.pleaseInput')"
                clearable
                maxlength="200"
                show-word-limit
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--内容-->
            <el-form-item :label="$t('customerManagements.content')" prop="textarea">
              <tinymce
                v-model="sysInfoObj.textarea"
                :height="280"
                :is-image="isImage"
                :msg-plugin="msgPlugin"
                :placeholder="$t('GlobalSetObj.pleaseInputContent') + '...'"
                :toolbar="toolbar"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="messageFooter">
      <!-- 取消 -->
      <el-button size="small" @click="clearForm">{{ $t('GlobalSetObj.cancel') }}</el-button>
      <!-- 确定 -->
      <el-button
        size="small" type="primary" @click="confirmDialog"
      >{{ $t('GlobalSetObj.determine') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { getLgAreaListData, getUserList, sendMessage } from '@/api/orderApi';
import { apiSearchProviderSite } from '@/api/automaticSorting';
import { getAllsite } from '@/api/logisticsOrders';
import Tinymce from '@/components/Tinymce/index.vue';

export default {
  name: 'NewMessage',
  components: {
    Tinymce
  },
  data() {
    return {
      textarea: '',
      msgPlugin: [''],
      toolbar: [''],
      siteList: [], // 网点
      sysInfoObj: {
        msgTypeInfo: 1, // 1 系统消息  2  公告
        msgType: 'TZ', // 更新提示
        providerId: [], // 投诉供应商
        isPop: true, // 是否弹框
        isWarning: false, // 虚假签收警告
        title: '', // 消息标题
        textarea: '', // 消息内容
        systemType: 0,
        clientType: 0,
        userList: [],
        reminder: 0,
        state: [],
        receiveUser: 1 // 接收用户
      },
      sysInfoObjRules: {
        title: [
          { required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' }
        ],
        textarea: [
          { required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'blur' }
        ],
        isWarning: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: 'change'
          }
        ]
      },
      siteData: [],
      siteListData: [],
      accountList: [],
      isDisable: false,
      providerList: [],
      StateList: [],
      isState: true,
      isProviderIdDisable: true,
      isImage: false
    };
  },
  mounted() {
    this.getAllSite();
    this.getSupperSite();
    this.getStateList();
    this.getAllUserList();
  },
  methods: {
    clearForm() {
      this.$refs['sysInfoRuleForm'].resetFields();
      this.sysInfoObj = {
        msgTypeInfo: 1, // 1 系统消息  2  公告
        msgType: 'TZ', // 更新提示
        providerId: [], // 投诉供应商
        isPop: true, // 是否弹框
        isWarning: false, // 虚假签收警告
        title: '', // 消息标题
        textarea: '', // 消息内容
        systemType: 0,
        clientType: 0,
        userList: [],
        reminder: 0,
        state: [],
        receiveUser: 1
      };
      this.isDisable = false;
      this.isProviderIdDisable = true;
      this.isState = true;
      this.accountList = [];
      this.providerList = [];
      this.siteList = [];
      this.$emit('child-event');
    },
    changeMsgTypeInfo(val) {
      console.log(val, 'valvalvalchangeMsgTypeInfo');
      this.sysInfoObj.providerId = [];
      this.sysInfoObj.clientType = 0;
      this.sysInfoObj.isPop = true;
      this.sysInfoObj.isWarning = false;
      this.sysInfoObj.systemType = 0;
      this.sysInfoObj.userList = [];
      this.sysInfoObj.reminder = 0;
      this.sysInfoObj.state = [];
      this.sysInfoObj.receiveUser = 1;
      this.sysInfoObj.textarea = '';
      if (val === 1) {
        this.isImage = false;
      } else {
        this.isImage = true;
      }
    },
    // 切换消息类型
    async handleSystemType(val) {
      console.log(val, 'valvalvalhandleSystemType');
      this.sysInfoObj.userList = [];
      this.sysInfoObj.providerId = [];
      this.sysInfoObj.state = [];
      this.sysInfoObj.clientType = 0;
      this.sysInfoObj.isWarning = false;
      if (val === 0) {
        this.isState = true;
        this.isProviderIdDisable = true;
        this.isDisable = true;
        this.sysInfoObj.receiveUser = 1;
      } else if (val === 1) {
        this.isState = false;
        this.isDisable = true;
        this.isProviderIdDisable = false;
      } else {
        this.isState = false;
        this.isDisable = false;
        this.isProviderIdDisable = false;
      }
      this.providerList = [];
      this.siteList = [];
      const data = {
        providerList: this.providerList,
        siteList: this.siteList,
        systemType: val
      };
      this.accountList = [];
      const res = await getUserList(data);
      if (res.code === 200) {
        if (res.data.users) {
          this.accountList = res.data.users;
        }
        if (res.data.pmUsers) {
          this.accountList = res.data.pmUsers;
        }
      }
    },
    changeState(val) {
      this.sysInfoObj.providerId = [];
      this.sysInfoObj.siteId = [];
      this.sysInfoObj.userList = [];
      this.sysInfoObj.isWarning = false;
      if (val && val.length) {
        this.isProviderIdDisable = true;
      } else {
        this.isProviderIdDisable = false;
        this.getAllUserList();
      }
    },
    handleClientType(val) {
    },
    // 切换接收用户
    changeReceiveUser(val) {
      this.sysInfoObj.userList = [];
      this.sysInfoObj.isWarning = false;
      this.sysInfoObj.providerId = [];
      this.sysInfoObj.siteId = [];
      this.sysInfoObj.state = [];
    },
    async confirmDialog() {
      this.$refs['sysInfoRuleForm'].validate((valid) => {
        if (valid) {
          const messageUserList = [];
          if (this.sysInfoObj.providerId.length) {
            this.sysInfoObj.providerId.forEach((item) => {
              messageUserList.push(item);
            });
          }
          // 定义图片数据的正则表达式，以'data:image'开头
          const imageDataRegex = /data:image/;
          if (imageDataRegex.test(this.sysInfoObj.textarea)) {
            this.$message.error(this.$t('GlobalSetObj.notInputImage'));
            return;
          }
          const data = {
            providerList: [],
            siteList: [],
            messageBody: {
              msgType: this.sysInfoObj.msgType,
              title: this.sysInfoObj.title,
              msgData: this.sysInfoObj.textarea,
              isPop: this.sysInfoObj.isPop, // 是否弹框
              isWarning: false,
              reminder: this.sysInfoObj.reminder
            },
            systemType: this.sysInfoObj.systemType,
            clientType: this.sysInfoObj.clientType,
            userList: [],
            siteStateList: []
          };
          if (this.sysInfoObj.receiveUser === 0) {
            if (
              this.providerList.length ||
              this.siteList.length ||
              this.sysInfoObj.userList.length ||
              this.sysInfoObj.state.length
            ) {
              data.providerList = this.providerList;
              data.siteList = this.siteList;
              data.userList = this.sysInfoObj.userList;
              data.siteStateList = this.sysInfoObj.state;
            } else {
              if (this.sysInfoObj.msgTypeInfo === 1) {
                this.$message.error(this.$t('spareNumberPoo.selectUser'));
                return;
              }
            }
          } else {
            data.userList = [-1];
          }
          data.messageBody.isWarning = this.sysInfoObj.isWarning;
          // return;
          if (this.sysInfoObj.msgTypeInfo === 2) {
            const data01 = {
              systemType: this.sysInfoObj.systemType,
              messageBody: {
                msgType: 'PROVIDE_NOTICE',
                title: this.sysInfoObj.title,
                msgData: this.sysInfoObj.textarea
              }
            };
            sendMessage(data01).then((res) => {
              console.log(123);
              if (res.code === 200) {
                this.clearForm();
                this.bus.$emit('getMessage');
                this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              }
            });
          } else {
            sendMessage(data).then((res) => {
              console.log(123);
              if (res.code === 200) {
                this.clearForm();
                this.bus.$emit('getMessage');
                this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    async getAllUserList(fuzzyFind = '') {
      this.accountList = [];
      const data = {
        providerList: this.providerList,
        siteList: this.siteList,
        systemType: this.sysInfoObj.systemType,
        fuzzyFind: fuzzyFind
      };
      const res = await getUserList(data);
      if (res.code === 200) {
        if (res.data.users) {
          this.accountList = res.data.users;
        }
        if (res.data.pmUsers) {
          this.accountList = res.data.pmUsers;
        }
      }
    },
    handleAllUserList(val) {
      if (val) {
        this.getAllUserList();
      }
    },
    changeUserList(val) {
      console.log(val, 'val');
      if (val && val.length === 0) {
        this.sysInfoObj.isWarning = false;
      }
    },
    // 切换对象
    async handleObj(val) {
      this.providerList = [];
      this.siteList = [];
      if (this.sysInfoObj.systemType === 1) {
        this.siteList = val;
        if (this.siteList.includes(-1)) {
          this.sysInfoObj.providerId = [-1];
          this.isDisable = true;
          this.siteList = [-1];
        } else {
          this.isDisable = false;
        }
      } else {
        const providreId = [];
        const siteId = [];
        val.forEach((item) => {
          if (item.length === 1) {
            providreId.push(item[0]);
          }
        });
        val.forEach((item) => {
          if (item.length === 2) {
            if (providreId.includes(item[0])) {
              console.log('重复了供应商');
            } else {
              siteId.push(item[1]);
            }
          }
        });
        if (providreId.includes(-1)) {
          this.sysInfoObj.providerId = [-1];
          this.providerList = [-1];
          this.isDisable = true;
          this.siteList = [];
        } else {
          this.isDisable = false;
          this.providerList = providreId;
          this.siteList = siteId;
        }
      }
      const data = {
        providerList: this.providerList,
        siteList: this.siteList,
        systemType: this.sysInfoObj.systemType
      };
      this.sysInfoObj.userList = [];
      this.sysInfoObj.isWarning = false;
      const res = await getUserList(data);
      if (res.code === 200) {
        if (res.data.users) {
          this.accountList = res.data.users;
        }
        if (res.data.pmUsers) {
          this.accountList = res.data.pmUsers;
        }
      }
    },
    // 获取对应的供应商下的网点
    getSupperSite() {
      apiSearchProviderSite().then((res) => {
        this.siteData = [];
        if (res.code === 200) {
          res.data.forEach((item) => {
            item.label = item.providerName;
            item.value = item.id;
            if (item.siteList && item.siteList.length > 0) {
              item.siteList.forEach((item) => {
                item.label = item.name;
                item.value = item.id;
              });
              item.children = item.siteList;
            }
          });
          this.siteData = [...res.data];
          this.siteData.unshift({
            label: this.$t('GlobalSetObj.all'),
            value: -1
          });
        }
      });
    },
    // 获取所有启用网点
    getAllSite() {
      this.siteListData = [];
      getAllsite().then((res) => {
        if (res.code === 200) {
          this.siteListData = res.data;
          this.siteListData.unshift({
            name: this.$t('GlobalSetObj.all'),
            id: -1
          });
        }
      });
    },
    // 州
    getStateList() {
      // level 0 州    1 城市   2 地区
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.messageFooter {
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: right;
  padding: 10px;
  bottom: 1px;
  border-top: 1px solid #cccccc;
}

/deep/ .el-form-item--small.el-form-item {
  margin-bottom: 10px !important;
}
</style>
